import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SubstitionAppAccessForm } from '../forms/SubstitionAppAccessForm';

type SubstitutionAppAccessModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const SubstitutionAppAccessModal = ({ isOpen, onClose }: SubstitutionAppAccessModalProps) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  return (
    <Modal
      loading={isLoading}
      title={t('substitutions.app.editAccess')}
      isOpen={isOpen}
      onRequestClose={() => onClose()}
    >
      <SubstitionAppAccessForm onLoad={setIsLoading} onClose={onClose} />
    </Modal>
  );
};
